import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DataService, DatasetBannerModel, DatasetBannerView} from 'src/app/services/data.service';
import {SessionService, UserType} from 'src/app/services/session.service';
// Rxjs
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {FileService} from 'src/app/services/file.service';

@Component({
  selector: 'app-forums',
  templateUrl: './forums.component.html',
  styleUrls: ['./forums.component.scss']
})
export class ForumsComponent implements OnInit {
  private params: Params;
  datasetId = 0;
  dataset: any = false;
  isReady = false;
  devMode = false;
  elements: any = [];
  enterpriseUser = false;
  meta: any = {
    total: 0,
    nb_page: 1,
    current_page: 1,
    first_page: 1,
    last_page: 1,
    count: 0,
    per_page: 20,
  };

  constructor(private router: Router,
              private route: ActivatedRoute,
              private trustiiService: TrustiiService,
              private dataservice: DataService,
              private sessionService: SessionService,
              public fileService: FileService,
              public datasetBannerModel: DatasetBannerModel) {
  }

  /**
   * Init component
   *
   * @return void
   */
  ngOnInit(): void {
    this.devMode = !environment.production;
    this.datasetBannerModel.setBannerView(DatasetBannerView.ForumView);
    this._loadParams$()
      .pipe(
        switchMap(this._loadDataset$.bind(this)),
        tap(this.getForums.bind(this))
      )
      .subscribe();
  }

  /** _loadParams$ method
   *
   * Load params and set class properties.
   * @return Observable<Params>
   */
  private _loadParams$(): Observable<Params> {
    return this.route.params
      .pipe(
        map((params: Params) => this.params = params)
      );
  }

  /** _loadDataset$ method
   *
   * Load dataset if there is id dataset on params.
   */
  private _loadDataset$(): Observable<any> {
    if (!this.params.datasetId || this.params.datasetId <= 0) {
      return of({});
    }
    this.datasetId = this.params.datasetId;
    return this.trustiiService.getDataset(this.datasetId).pipe(
      map((dataset: any) => this.dataset = dataset.data),
      tap(() => {
        if (this.dataset.accountId === this.sessionService.getUser().roleId) {
          this.enterpriseUser = true;
        } else {
          this.enterpriseUser = false;
        }
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  /**
   * Get forum
   */
  getForums(): void {
    this.dataservice.data.trainigData = this.datasetId;
    this.trustiiService.getForums(this.datasetId, this.meta.page, this.meta.per_page).subscribe(
      (res) => {
        this.elements = res.data;
        this.meta = res.meta;
        this.isReady = true;
      },
      (err) => {
        this.isReady = true;
        this.elements = [];
      }
    );
  }

  /**
   * When limit changed
   *
   * @param perPage Nb result per page
   */
  onLimitChanged(perPage: number): void {
    this.meta.per_page = perPage;
    this.getForums();
  }

  /**
   * When page changed
   *
   * @param page The page
   */
  onPageChanged(page: number): void {
    this.meta.page = page;
    this.getForums();
  }

  /**
   * Format date
   *
   * @param stringDate The date
   * @return Local date
   */
  formatDate(stringDate: string): string {
    const date = new Date(stringDate);
    return date.toLocaleString();
  }
}
